import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Resolve an image/file path returned by the API into an absolute URL.
 * Backend-relative paths (e.g. "/api/static/blog-covers/x.jpg") are served by
 * the FastAPI backend, NOT the frontend host. Prefixing with the backend URL
 * makes images load in every environment (preview AND the production domain).
 * Absolute http(s), data:, and blob: URLs are returned untouched.
 */
export function imgUrl(path) {
  if (!path) return path;
  if (/^(https?:)?\/\//i.test(path) || path.startsWith("data:") || path.startsWith("blob:")) {
    return path;
  }
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  if (path.startsWith("/")) return `${BACKEND_URL}${path}`;
  return path;
}

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nc_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
